<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Techno/Cyber/Xeno-Feminism</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, reader</p>
        <p><i>Techno/Cyber/Xeno-Feminism: The Intimate and Possibly Subversive Relationship Between Women and Machines</i> Reader explores topics from women's introduction into the technological workforce, the connection between weaving and programming, and using technology in favour of the feminist movement. One major concept that appears throughout the reader is an almost mystical connection between women and software writing, embedded deep in women's tradition of weaving not just threads, but networks. Does software have a gender?
        </p>

        <p>The reader was developed using free software, in the context of the <a href="https://issue.xpub.nl/05/">OuNuPo Special Issue</a>, at the Piet Zwart Institute. The publication was displayed at the <a href="https://gaite-lyrique.net/evenement/grrrls-tech-zine-fair">Grrrls Tech Zine Fair</a>, at Le Gaîté Lyrique, Paris.</p>


      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/xeno/Xeno.jpg"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/xeno/thumbnail.jpeg"></b-img>
      </b-col>
      <b-col md="4">
      <b-img class="img-fluid" src="media/xeno/readers.jpeg"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/xeno/zinefair.png"></b-img>

      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'XenoPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
